if (!customElements.get('collection-tab-pages')) {
  customElements.define('collection-tab-pages', class extends HTMLElement {
    connectedCallback() {
      this.panels = [...this.querySelectorAll('.collection-tab-pages__panel')];
      this.panel = this.panels.find((panel) => !panel.hidden);
      this.index = 0;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-page-prev]')) this.goTo(this.index - 1);
        if (event.target.closest('[data-page-next]')) this.goTo(this.index + 1);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (!event.target.matches('.collection-tab-pages__viewport')) return;
        const previous = this.mobile.matches ? 'ArrowLeft' : 'ArrowUp';
        const next = this.mobile.matches ? 'ArrowRight' : 'ArrowDown';
        if (event.key !== previous && event.key !== next) return;
        event.preventDefault();
        this.goTo(this.index + (event.key === next ? 1 : -1));
      }, options);
      this.panels.forEach((panel) => {
        panel.querySelector('.collection-tab-pages__viewport').addEventListener('scroll', () => {
          if (panel !== this.panel || !this.mobile.matches) return;
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const viewport = this.viewport;
            this.index = Math.max(0, Math.min(this.pages.length - 1, Math.round(Math.abs(viewport.scrollLeft) / (viewport.clientWidth || 1))));
            this.updateControls();
          });
        }, { ...options, passive: true });
      });
      this.mobile.addEventListener('change', () => this.render(), options);
      this.resizeObserver = new ResizeObserver(() => {
        if (this.mobile.matches) this.scrollToPage('instant');
      });
      this.resizeObserver.observe(this);
      this.classList.add('is-initialized');
      this.render();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
    }

    get viewport() { return this.panel?.querySelector('.collection-tab-pages__viewport'); }
    get pages() { return this.panel ? [...this.panel.querySelectorAll('.collection-tab-pages__page')] : []; }

    selectCollection(handle) {
      const panel = this.panels.find((item) => item.dataset.collection === handle);
      if (!panel) return;
      cancelAnimationFrame(this.scrollFrame);
      this.panel = panel;
      this.panels.forEach((item) => { item.hidden = item !== panel; });
      this.index = 0;
      this.render();
    }

    goTo(index) {
      this.index = Math.max(0, Math.min(index, this.pages.length - 1));
      if (this.mobile.matches) {
        this.scrollToPage(window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
        this.updateControls();
      } else this.render();
    }

    scrollToPage(behavior) {
      const viewport = this.viewport;
      if (!viewport) return;
      const direction = getComputedStyle(viewport).direction === 'rtl' ? -1 : 1;
      viewport.scrollTo({ left: direction * this.index * viewport.clientWidth, behavior });
    }

    render() {
      // 一页始终包含四个商品，切换设备只改变排列方式。
      this.pages.forEach((page, index) => { page.hidden = !this.mobile.matches && index !== this.index; });
      if (this.mobile.matches) this.scrollToPage('instant');
      this.updateControls();
    }

    updateControls() {
      const count = this.pages.length;
      this.querySelector('.collection-tab-pages__navigation').hidden = count <= 1;
      this.querySelector('[data-page-prev]').disabled = this.index <= 0;
      this.querySelector('[data-page-next]').disabled = this.index >= count - 1;
      const progress = this.querySelector('.collection-tab-pages__progress');
      if (progress) {
        progress.hidden = count <= 1;
        progress.style.setProperty('--page-progress', String((this.index + 1) / (count || 1)));
      }
      this.querySelector('[data-page-status]').textContent = count ? `Page ${this.index + 1} of ${count}` : '';
    }
  });
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.buttons = [...this.querySelectorAll('button[data-collection]')];
      this.links = this.closest('.section-header')?.querySelectorAll('.linked-to-tab') || [];
      this.buttons.forEach((button, index) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('active')));
        button.addEventListener('click', () => this.select(index), { signal: this.controller.signal });
      });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.buttons.indexOf(event.target.closest('button[data-collection]'));
        if (index >= 0) this.select(index);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() { this.controller?.abort(); }

    select(index) {
      this.buttons.forEach((button, current) => {
        button.classList.toggle('active', current === index);
        button.setAttribute('aria-pressed', String(current === index));
      });
      this.links.forEach((link, current) => link.classList.toggle('active', current === index));
      const slider = document.getElementById(this.dataset.target);
      const handle = this.buttons[index].dataset.collection;
      if (typeof slider?.selectCollection === 'function') {
        slider.selectCollection(handle);
        return;
      }
      // 兼容其他仍使用旧 Flickity 列表的调用方。
      const flickity = window.Flickity?.data(slider);
      if (!slider || !flickity) return;
      const products = [...slider.querySelectorAll('[data-collection]')];
      const active = products.filter((product) => product.dataset.collection === handle);
      products.forEach((product) => {
        product.classList.toggle('carousel__slide', product.dataset.collection === handle);
        if (product.dataset.collection !== handle) slider.append(product);
      });
      flickity.insert(active);
      flickity.reloadCells();
      flickity.select(0, false, true);
    }
  });
}
